import { render } from "./CurrentRestaurantSettings.vue?vue&type=template&id=68ce3a26&scoped=true"
import script from "./CurrentRestaurantSettings.vue?vue&type=script&lang=js"
export * from "./CurrentRestaurantSettings.vue?vue&type=script&lang=js"

import "./CurrentRestaurantSettings.vue?vue&type=style&index=0&id=68ce3a26&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\php\\Resturant-POS-PHP-VUE-MODULE\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68ce3a26"]])

export default __exports__